import { getLocation } from "@src/appV2/redesign/utils/routes";
import { useOpenUrl } from "@src/mobile/utils/openUrl";
import { useCallback } from "react";

interface UseViewProfileHandlerParams {
  workerId: string;
  onViewProfile?: (workerId: string) => void;
}

export function useViewProfileHandler(params: UseViewProfileHandlerParams) {
  const { workerId, onViewProfile } = params;
  const openUrl = useOpenUrl();

  return useCallback(() => {
    if (onViewProfile) {
      onViewProfile(workerId);
      return;
    }
    const location = getLocation("workplaceWorkerDetails", { pathParams: { workerId } });
    void openUrl(`${globalThis.location.origin}${location.pathname}`);
  }, [workerId, onViewProfile, openUrl]);
}
